import * as React from 'react'

import Select, {SelectableItem} from 'airship/patterns/select'

interface Props<Id extends string = string> {
  name: string
  selected: string | undefined
  onSelect: (arg: string) => void
  items: readonly SelectableItem<Id>[]
  defaultItemText?: string
  optionalLabel?: boolean
}

const AdditionalSelect: React.FC<Props> = ({
  name,
  selected,
  onSelect,
  items,
  defaultItemText,
  optionalLabel,
}) => {
  return (
    <>
      <div className="u-flex">
        <p className="u-text-bold u-text-grow-2 u-space-bottom-05">{name}</p>
        {optionalLabel && <p className="u-space-left-05">(Optional)</p>}
      </div>

      <Select
        displayClasses="u-space-bottom-05"
        items={items}
        selected={selected}
        onSelect={onSelect}
        defaultItemText={defaultItemText}
      />
    </>
  )
}

export default AdditionalSelect
